import React from "react";
import { FaHome, FaUsers, FaFileAlt } from "react-icons/fa";
import styles from "./BottomBar.module.scss";
import { useLocation, useNavigate } from "react-router-dom";

interface BottomBarProps {
    menu: { label: string; href: string, icon: React.ReactNode }[];
}

const BottomBar: React.FC<BottomBarProps> = ({ menu }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const currentPath = location.pathname;

  return (
    <div className={styles.bottomBar}>
      {menu.map((item) => (
        <button key={item.href} onClick={() => navigate(item.href)} className={currentPath === item.href ? styles.active : ""}>
          {item.icon}
          <span>{item.label}</span>
        </button>
      ))}
    </div>
  );
};

export default BottomBar;
